import { render, staticRenderFns } from "./Pencatatan_Utang.vue?vue&type=template&id=3ec139ca"
import script from "./Pencatatan_Utang.vue?vue&type=script&lang=js"
export * from "./Pencatatan_Utang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports